import "react-app-polyfill/stable"; /** Support IE11 */
import "react-app-polyfill/ie11"; /** Support IE11 */
import "es6-object-assign"; /** Support IE11 - Assign Object */
import {
  validateForm,
  setDisplay,
  removeErrorsOnChange,
  removeInputError
} from '../helpers';
import { getPayload } from "../new_register";
import { formatNumber, avoidNotNumberKey } from '../../src/components/common';
import { Capitalize } from "../../src/libs/formatting";
import { errorMessages } from "../../src/ErrorConfig/errorConfig";

let tableRow, xhttp, selectedRow;

let searchBtn = document.getElementById("search-btn");
const recaptchaElement = document.querySelector('.g-recaptcha');
const submitButton = document.getElementById('submit-btn');
const nextButton = document.getElementById('next-btn');

let recaptchaFilled = false;
let selectedProviders = [];
let providers = [];

const optionsDropdown = document.getElementById('optionsDropdown');
const healthPlanObject = Array.from(optionsDropdown.querySelectorAll('li')).map(li => {
  const input = li.querySelector('input[type="checkbox"]');
  const label = li.querySelector('label');

  return {
    id: input.value,
    name: label.querySelector('span').textContent.trim(),
  };
});

let activeHealthplanName = '';
let activeHealthplanId = '';


const disableSubmit = () => {
  if (submitButton) {
    submitButton.setAttribute('disabled', '')
    submitButton.classList.remove("button--purple")
    submitButton.classList.add("disabled")
  }
}

const enableSubmit = () => {
  if (submitButton && recaptchaFilled) {
    submitButton.removeAttribute('disabled')
    submitButton.classList.add("button--purple")
    submitButton.classList.remove("disabled")
  };
}

const sendLogEvent = message => {
  const payload = getPayload();
  const logPayload = JSON.stringify({ "email": payload.user.email, "data": { "message": message } })
  const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

  xhttp = new XMLHttpRequest();
  xhttp.open(
    'POST',
    '/api/v1/log_events',
    true
  );

  xhttp.setRequestHeader('Accept', 'application/json');
  xhttp.setRequestHeader('Content-type', 'application/json');
  xhttp.setRequestHeader('X-CSRF-Token', token);

  xhttp.send(logPayload);
}

const disableNext = () => {
  if (nextButton) {
    nextButton.setAttribute('disabled', '')
    nextButton.classList.remove("button--purple")
    nextButton.classList.add("disabled")
  }
}

const enableNext = () => {
  if (nextButton) {
    nextButton.removeAttribute('disabled')
    nextButton.classList.add("button--purple")
    nextButton.classList.remove("disabled")
  };
}

export const getActiveHealthPlan = (payload) => {
  const activeHp = payload['health_plans'].find((healthPlan) => healthPlan.active);
  const activeHpName = healthPlanObject.find((healthPlanOb) => healthPlanOb.id === activeHp.internal_id);

  document.querySelector('.healthplan_name').innerHTML = activeHpName.name;
  activeHealthplanName = activeHpName.name;
  activeHealthplanId = activeHpName.id;
  document.querySelector('#health_plan_count .hp_active_count').innerHTML = payload['health_plans'].findIndex((healthPlan) => healthPlan.active) + 1;
  document.querySelector('#health_plan_count .hp_total_count').innerHTML = payload['health_plans'].length;
  payload['health_plans'].length > 1 && setDisplay('#health_plan_count', 'block');
}

const renderButton = (gdfId, hpId) => {
  let selectedGdfId = [];
  if (selectedProviders && selectedProviders.length > 0) {
    selectedGdfId = selectedProviders.map((prov) => [prov.gdf_id, prov.hp_id.replaceAll(' ', '')]);
  }
  const included = selectedGdfId.some(subArray =>
    subArray.every((value, index) => value === [gdfId, hpId][index])
  );
  if (selectedGdfId.length > 0 && included) {
    return `<button id="facility_${gdfId}_${hpId}" class="select-button select-button--checked button--default" type="button">Remove</button>`
  } else {
    return `<button id="select_${gdfId}_${hpId}" class="select-button button--default" type="button">Select</button>`
  }
}

const getFacilityRow = (data) => {
  const {
    location_name,
    address,
    city,
    state,
    npi_code,
    phone,
    zip,
    gdf_id
  } = data;

  return `<tr>
            <td>${activeHealthplanName}</td>
            <td>${Capitalize(location_name)}</td>
            <td>${Capitalize(address)}</td>
            <td>${Capitalize(city)}</td>
            <td>${state}</td>
            <td>${zip}</td>
            <td>${formatNumber(phone)}</td>
            <td>${npi_code}</td>
            <td>
              ${renderButton(gdf_id, activeHealthplanId.replaceAll(' ', ''))}
            </td>
          </tr>`;
};

const getLocations = () => {
  providers = [];

  if (xhttp.readyState === 4) {
    if (xhttp.status === 200) {
      const response = xhttp.response && xhttp.response.length > 0 ? JSON.parse(xhttp.response) : [];
      if (response.length === 0) {
        if (selectedProviders.length > 0) {
          setDisplay('#loader', 'none');
          searchBtn.disabled = false;
          setDisplay('#empty-state', 'flex');
          document.querySelector('#empty-state .empty-state__title').innerHTML = errorMessages.updateYourCriteria;
          document.querySelector('#empty-state .empty-state__desc').innerHTML = 'This search did not retrieve any results.';
        } else {
          setDisplay('#loader', 'none');
          searchBtn.disabled = false;
          setDisplay('.pardon-our-dust', 'none');
          setDisplay('.user-created', 'none');
          setDisplay('.based-our-records', 'none');
          setDisplay('.no-records', 'block');
          setDisplay('.register-modal', 'flex');
          setDisplay('#empty-state', 'flex');
          document.querySelector('#empty-state .empty-state__title').innerHTML = "Enter Provider's Information";
          document.querySelector('#empty-state .empty-state__desc').innerHTML = 'Perform a search above to find the correct provider.';
        }
      } else if (response.message) {
        if (selectedProviders.length > 0) {
          setDisplay('#loader', 'none');
          searchBtn.disabled = false;
          setDisplay('#empty-state', 'flex');
          document.querySelector('#empty-state .empty-state__title').innerHTML = errorMessages.updateYourCriteria;
          document.querySelector('#empty-state .empty-state__desc').innerHTML = 'This search did not retrieve any results.';
        } else {
          setDisplay('#loader', 'none');
          searchBtn.disabled = false;
          setDisplay('.pardon-our-dust', 'none');
          setDisplay('.user-created', 'none');
          setDisplay('.no-records', 'none');
          setDisplay('.based-our-records', 'block');
          document.querySelector('.based-our-records p').innerHTML = response.message;
          setDisplay('.register-modal', 'flex');
          setDisplay('#empty-state', 'flex');
          document.querySelector('#empty-state .empty-state__title').innerHTML = "Enter Provider's Information";
          document.querySelector('#empty-state .empty-state__desc').innerHTML = 'Perform a search above to find the correct provider.';
        }
      } else {
        providers = response;
      }
    } else if (xhttp.status === 400 || xhttp.status === 401) {
      if (selectedProviders.length > 0) {
        setDisplay('#loader', 'none');
        searchBtn.disabled = false;
        setDisplay('#empty-state', 'flex');
        document.querySelector('#empty-state .empty-state__title').innerHTML = errorMessages.updateYourCriteria;
        document.querySelector('#empty-state .empty-state__desc').innerHTML = 'This search did not retrieve any results.';
      } else {
        setDisplay('#loader', 'none');
        searchBtn.disabled = false;
        setDisplay('.pardon-our-dust', 'none');
        setDisplay('.user-created', 'none');
        setDisplay('.no-records', 'none');
        setDisplay('.based-our-records', 'block');
        document.querySelector('.based-our-records p').innerHTML = JSON.parse(xhttp.response).error || errorMessages.notContractedProvider;
        setDisplay('.register-modal', 'flex');
        setDisplay('#empty-state', 'flex');
        document.querySelector('#empty-state .empty-state__title').innerHTML = "Enter Provider's Information";
        document.querySelector('#empty-state .empty-state__desc').innerHTML = 'Perform a search above to find the correct provider.';
      }
    } else if (xhttp.status === 422 && JSON.parse(xhttp.response).error) {
      setDisplay('#loader', 'none');
      searchBtn.disabled = false;
      setDisplay('.pardon-our-dust', 'none');
      setDisplay('.user-created', 'none');
      setDisplay('.no-records', 'none');
      setDisplay('.based-our-records', 'block');
      document.querySelector('.based-our-records p').innerHTML = JSON.parse(xhttp.response).error;
      setDisplay('.register-modal', 'flex');
      setDisplay('#empty-state', 'flex');
      document.querySelector('#empty-state .empty-state__title').innerHTML = "Enter Provider's Information";
      document.querySelector('#empty-state .empty-state__desc').innerHTML = 'Perform a search above to find the correct provider.';
    } else if (xhttp.status === 500) {
      setDisplay('#loader', 'none');
      searchBtn.disabled = false;
      setDisplay('.alert-container', 'block');
      setDisplay('.alert.error', 'flex');
      var alertClose = document.getElementById('js-alert-close');
      alertClose.onclick = () => setDisplay('.alert-container', 'none');
      setTimeout(() => { setDisplay('.alert-container', 'none') }, 5000)
      document.querySelector('.alert__title').innerHTML = errorMessages.troubleRetrievingResults;
      document.querySelector('.alert__description').innerHTML = errorMessages.tryAgainLater;
    } else if (xhttp.status === 422 && JSON.parse(xhttp.response).error === null && JSON.parse(xhttp.response).displayString) {
      setDisplay('#loader', 'none');
      searchBtn.disabled = false;
      setDisplay('#empty-state', 'flex');
      document.querySelector('#empty-state .empty-state__title').innerHTML = JSON.parse(xhttp.response).displayString;
      document.querySelector('#empty-state .empty-state__desc').innerHTML = errorMessages.updateYourCriteria;
    }

    if (providers.length >= 1) {
      document.querySelector('.search-locations-table tbody').innerHTML = '';
      providers.forEach(fillLocationsTable);
    }
    document.getElementById('search-list').scrollTop = 0;
  }
};

const verifyProvider = () => {
  searchBtn.disabled = true;
  setDisplay('#empty-state', 'none');
  setDisplay('#loader', 'flex');
  setDisplay('#search-list', 'none');
  let dataPayload = getPayload();
  const location_name = document.getElementById('User_location_name').value;
  const npi = document.getElementById('User_npi').value;
  const email_address = dataPayload.user.email;
  const user_type = dataPayload.user.user_type;
  const health_plan = activeHealthplanId;
  const portal_provider_type = dataPayload.user.provider_type;

  xhttp = new XMLHttpRequest();
  xhttp.onreadystatechange = getLocations;
  xhttp.open(
    'POST',
    '/api/v1/providers/verify',
    true
  );
  xhttp.setRequestHeader('Accept', 'application/json');
  xhttp.setRequestHeader('Content-type', 'application/json');
  const data = {
    providers: {
      npi,
      location_name,
      email_address,
      user_type,
      health_plan,
      portal_provider_type
    }
  };
  xhttp.send(JSON.stringify(data));
};

searchBtn.addEventListener("click", function (e) {
  e.preventDefault();
  const requiredFields = document.querySelectorAll('[required="required"]');
  const isValidated = validateForm(requiredFields);
  if (isValidated.isValid) {
    setDisplay('.alert-container', 'none');
    verifyProvider();
  }
});

const selectProviderFromList = (e, data) => {
  if (e) e.preventDefault();
  const removeBtn = document.createElement('button');
  removeBtn.setAttribute("class", 'select-button select-button--checked button--default');
  removeBtn.innerText = 'Remove';
  removeBtn.onclick = function () { removeProviderFromList(e, data) };
  removeBtn.setAttribute("id", `facility_${data.gdf_id}_${data.hp_id.replaceAll(' ', '')}`);
  const selectBtn = document.getElementById(`select_${data.gdf_id}_${data.hp_id.replaceAll(' ', '')}`);
  selectBtn.replaceWith(removeBtn);
  updateArrayData(data);
  addInTheTableData(data);
}

const removeProviderFromList = (e, data) => {
  if (e) e.preventDefault();
  updateArrayData(data);
  removeFromTableData(e, data);
}

const updateArrayData = (data) => {
  let index = selectedProviders.findIndex(o => (o.gdf_id === data.gdf_id && o.hp_id === data.hp_id));
  if (index === -1) {
    selectedProviders.push(data);
  } else {
    selectedProviders.splice(index, 1);
  }

  document.getElementById('result-count').innerHTML = selectedProviders.length;

  if (selectedProviders.length <= 0) {
    setDisplay('#selected_empty-state', 'flex');
    setDisplay('#selected-list', 'none');
  }
  else if (!document.querySelector('.icon-back.icon-back--clicked')) {
    const collapElement = document.querySelector('.icon-back')
    collapElement.classList.add('icon-back--clicked');
    document.getElementsByClassName('register__collapsible')[0].classList.add('register__collapsible--open')
  }

  if (recaptchaFilled && selectedProviders.length > 0) {
    enableSubmit()
    enableNext()
  } else {
    disableSubmit()
    disableNext()
  }
}

const addInTheTableData = (data) => {
  selectedRow = '';
  selectedRow += getFacilityRow(data);
  const payload = getPayload();

  if (selectedProviders.length > 0) {
    setDisplay('#selected_empty-state', 'none');
    setDisplay('#selected-list', 'block');
  }
  document
    .querySelector('.selected-locations-table tbody')
    .insertAdjacentHTML('afterbegin', selectedRow);

  const { hp_id, gdf_id, lob, non_contracted_flag, npi_code } = data;
  const index = payload['health_plans'].findIndex((e) => e.active === true);
  if (!payload['health_plans'][index]['locations']) payload['health_plans'][index]['locations'] = []

  payload['health_plans'][index]['locations'].push({
    hp_id,
    gdf_id,
    lob,
    non_contracted_flag,
    npi: npi_code
  })

  const healthPlanIndex = selectedProviders.findIndex((provider) => provider.hp_id === activeHealthplanId)
  if (healthPlanIndex > -1) {
    enableNext();
    enableSubmit();
  } else {
    disableNext();
    disableSubmit();
  }

  const elem = document.getElementById(`facility_${data.gdf_id}_${data.hp_id.replaceAll(' ', '')}`);
  elem && elem.addEventListener("click", function (e) { removeProviderFromList(e, data) });
}

const removeFromTableData = (e, data) => {
  if (e) e.preventDefault();
  const removingElem = document.querySelector(`#selected-list #facility_${data.gdf_id}_${data.hp_id.replaceAll(' ', '')}`);
  if (removingElem) removingElem.parentElement.parentElement.remove();

  const payload = getPayload();
  if (payload['health_plans']) {
    const index = payload['health_plans'].findIndex((el) => el.internal_id === data.hp_id);
    // Remove the corresponding location from the payload
    if (payload['health_plans'][index] && payload['health_plans'][index]['locations']) {
      const locationIndex = payload['health_plans'][index]['locations'].findIndex(
        (location) => location.gdf_id === data.gdf_id && location.hp_id === data.hp_id
      );
      if (locationIndex !== -1) {
        payload['health_plans'][index]['locations'].splice(locationIndex, 1);
      }
    }
  }
  const healthPlanIndex = selectedProviders.findIndex((provider) => provider.hp_id === activeHealthplanId)
  if (healthPlanIndex > -1) {
    enableNext();
    enableSubmit();
  } else {
    disableNext();
    disableSubmit();
  }
  if (e) {
    const selectButton = document.createElement('button');
    selectButton.setAttribute("class", 'select-button button--default');
    selectButton.innerText = 'Select';
    selectButton.onclick = function () { selectProviderFromList(e, data) };
    selectButton.setAttribute("id", `select_${data.gdf_id}_${data.hp_id.replaceAll(' ', '')}`);
    const removeButton = document.getElementById(`facility_${data.gdf_id}_${data.hp_id.replaceAll(' ', '')}`);
    removeButton.replaceWith(selectButton);
  }
}

const fillLocationsTable = ({ locations, gdf_id, non_contracted_flag, hp_id }) => {
  tableRow = '';
  tableRow += getFacilityRow({ ...locations[0], gdf_id });
  setDisplay('#loader', 'none');
  setDisplay('#search-list', 'block');
  document
    .querySelector('.search-locations-table tbody')
    .insertAdjacentHTML('beforeend', tableRow);
  searchBtn.disabled = false;


  const removeElem = document.querySelector(`#search-list #facility_${gdf_id}_${activeHealthplanId.replaceAll(' ', '')}`);
  const elem = document.querySelector(`#search-list #select_${gdf_id}_${activeHealthplanId.replaceAll(' ', '')}`);

  if (elem) {
    elem.addEventListener("click", function (e) {
      selectProviderFromList(e, { ...locations[0], gdf_id: gdf_id, hp_id: activeHealthplanId, non_contracted_flag: non_contracted_flag });
    });
  } else if (removeElem) {
    removeElem.addEventListener("click", function (e) {
      removeProviderFromList(e, { ...locations[0], gdf_id: gdf_id, hp_id: activeHealthplanId, non_contracted_flag: non_contracted_flag });
    });
  }

  const elemSelected = document.querySelector(`#selected-list #select_${gdf_id}_${activeHealthplanId.replaceAll(' ', '')}`);

  if (elemSelected) {
    elemSelected.addEventListener("click", function (e) {
      selectProviderFromList(e, { ...locations[0], gdf_id: gdf_id, hp_id: activeHealthplanId, non_contracted_flag: non_contracted_flag });
    });
  }

};

const npiField = document.querySelector("#User_npi");

npiField.addEventListener('keypress', (e) => avoidNotNumberKey);

npiField.addEventListener('input', (e) => {
  e.preventDefault();
  e.target.value = e.target.value.replace(/[^0-9\.]/g, '');
});

document.getElementById('User_location_name').addEventListener('keypress', (e) => {
  if (e.key === 'Enter') e.preventDefault();
});

document.getElementById('selected-collapsible').addEventListener('click', (e) => {
  e.preventDefault();
  if (e.target.classList.contains('icon-back')) {
    e.target.classList.toggle('icon-back--clicked');
  } else {
    e.target.parentNode.classList.toggle('icon-back--clicked');
  }
  document.getElementsByClassName('register__collapsible')[0].classList.toggle('register__collapsible--open');
});

document.getElementById('clear-button').addEventListener('click', (e) => {
  e.stopPropagation();
  let locationName = document.getElementById('User_location_name').value;
  let npi = document.getElementById('User_npi').value;
  if (locationName) document.getElementById('User_location_name').value = "";
  if (npi) document.getElementById('User_npi').value = "";
});

const requiredFields = document.querySelectorAll('[required="required"]');
setTimeout(() => removeErrorsOnChange(requiredFields))

//Comment this to disable captcha
window.recaptcha = () => {
  recaptchaFilled = true;
  sendLogEvent("reCAPTCHA completed successfully");
  const healthPlanIndex = selectedProviders.findIndex((provider) => provider.hp_id === activeHealthplanId)
  if (selectedProviders.length > 0 && healthPlanIndex > -1) enableSubmit()
}
recaptchaElement.setAttribute('data-callback', 'recaptcha');

window.recaptchaExpired = () => {
  sendLogEvent("reCAPTCHA completed failed Expired");
  disableSubmit();
}

window.recaptchaFailed = (e) => {
  sendLogEvent("reCAPTCHA completed failed "+ e);
}

recaptchaElement.setAttribute('data-expired-callback', 'recaptchaExpired');
recaptchaElement.setAttribute('data-error-callback', 'recaptchaFailed');
//End captcha

recaptchaFilled && selectedProviders.length > 0 && enableSubmit()

const nextHealthPlan = () => {
  const payload = getPayload();
  const locations = [];
  const index = payload['health_plans'].findIndex(({ internal_id }) => internal_id === activeHealthplanId);
  selectedProviders.forEach(({ hp_id, gdf_id, lob, non_contracted_flag, npi_code }) => {
    locations.push({
      hp_id,
      gdf_id,
      lob,
      non_contracted_flag,
      npi: npi_code
    });
  });
  payload['health_plans'][index].active = false;

  if (index < payload['health_plans'].length - 1) {
    payload['health_plans'][index + 1].active = true;
  }
  disableNext();
  if (index + 1 >= payload['health_plans'].length - 1) {
    setDisplay('.next-container', 'none');
    setDisplay('.submit-container', 'block');
    setDisplay('.captcha', 'block');
    setDisplay('.subtitle', 'block');
    const submitButton = document.getElementById('submit-btn');
    submitButton.addEventListener("click", submitForm)
  }
  getActiveHealthPlan(payload)
  resetFields();
  return payload;
}

const respondToVisibility = (element, callback) => {
  var options = {
    root: document.documentElement
  }

  var observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      callback(entry.intersectionRatio > 0);
    });
  }, options);

  observer.observe(element);
}
let nextButtonSet = false;
let submitButtonSet = false;
respondToVisibility(document.getElementById("step2-view"), visible => {
  if (visible) {
    let dataPayload = getPayload();
    if (dataPayload.health_plans.length > 1) {
      setDisplay('.next-container', 'block');
      setDisplay('.submit-container', 'none');
      setDisplay('.captcha', 'none');
      setDisplay('.subtitle', 'none');
      const nextBtn = document.getElementById('next-btn');
      if (!nextButtonSet) {
        nextBtn.addEventListener('click', () => {
          nextHealthPlan();
        })
        nextButtonSet=true;
      }
    } else {
      setDisplay('.next-container', 'none');
      setDisplay('.submit-container', 'block');
      setDisplay('.captcha', 'block');
      setDisplay('.subtitle', 'block');
      if (!submitButtonSet) {
        const submitButton = document.getElementById('submit-btn');
        submitButton.addEventListener("click", submitForm)
        submitButtonSet = true
      }
    }
  }
});

const resetFields = () => {
  let locationName = document.getElementById('User_location_name').value;
  let npi = document.getElementById('User_npi').value;
  if (locationName) document.getElementById('User_location_name').value = "";
  if (npi) document.getElementById('User_npi').value = "";
  providers = []
  document.querySelector('#empty-state .empty-state__title').innerHTML = "Enter Provider's Information";
  document.querySelector('#empty-state .empty-state__desc').innerHTML = "Perform a search above to find the correct provider.";
  setDisplay('#empty-state', 'flex');
  setDisplay('#loader', 'none');
  setDisplay('#search-list', 'none');
}

function flattenPayloadAndCreateFields(prefix, obj, form) {
  for (const key in obj) {
    const fieldName = prefix ? `${prefix}[${key}]` : key;
    const value = obj[key];

    if (Array.isArray(value)) {
      value.forEach((item, index) => {
        flattenPayloadAndCreateFields(`${fieldName}[${index}]`, item, form);
      });
    } else if (typeof value === 'object' && value !== null) {
      flattenPayloadAndCreateFields(fieldName, value, form);
    } else {
      const inputField = document.createElement('input');
      inputField.type = 'hidden';
      inputField.name = fieldName;
      inputField.value = typeof value === 'string' ? value : JSON.stringify(value);
      form.appendChild(inputField);
    }
  }
}

const submitForm = () => {
  const payload = getPayload();
  const locations = [];
  const index = payload['health_plans'].findIndex(({ internal_id }) => internal_id === activeHealthplanId);
  selectedProviders.forEach(({ hp_id, gdf_id, lob, non_contracted_flag, npi_code }) => {
    locations.push({
      hp_id,
      gdf_id,
      lob,
      non_contracted_flag,
      npi: npi_code
    });
  });
  payload['health_plans'][index].active = false;

  const userData = payload['user'];
  const healthPlansData = payload["health_plans"];
  const existingForm = document.getElementById('new_User');
  const existingFormAction = existingForm.getAttribute('action')

  const hiddenForm = document.createElement('form');
  hiddenForm.action = existingFormAction;
  hiddenForm.method = "POST";
  hiddenForm.style.display = 'none';

  const input = document.createElement('input');
  const csrfToken = document.head.querySelector('meta[name="csrf-token"]').content;
  input.type = 'hidden';
  input.name = 'authenticity_token';
  input.value = csrfToken;
  hiddenForm.appendChild(input);

  flattenPayloadAndCreateFields('user', userData, hiddenForm);
  const healthPlansInput = document.createElement('input');
  healthPlansInput.type = 'hidden';
  healthPlansInput.name = 'health_plans';
  healthPlansInput.value = JSON.stringify(healthPlansData);
  hiddenForm.appendChild(healthPlansInput);

  document.body.appendChild(hiddenForm);
  disableSubmit();
  submitButton.innerText = "Loading..."

  hiddenForm.submit();
}

const clearAllData = () => {
  JSON.parse(JSON.stringify(selectedProviders)).forEach((data) => {
    updateArrayData(data)
    removeFromTableData(null, data)
  })
 
  selectedProviders = [];
  resetFields();
  disableSubmit();
  disableNext();
}

const triggerBackBtnStep2 = () => {
  const backHome = document.querySelector('.back');
  const backBtn = document.querySelector('.btn-back');

  if (backHome) {
    backHome.addEventListener('click', (event) => {
      const requiredFields = document.querySelectorAll('[required="required"]');
      requiredFields.forEach((field) => {
        removeInputError(field);
        field.classList.remove('error');
      })
      setDisplay('.alert-container', 'none');
      if (document.querySelector("#step2-view.active")) {
        event.preventDefault();
        clearAllData();
        document.querySelector("#step2").classList.remove("active");
        document.querySelector("#step1-view").classList.add("active");
        document.querySelector("#step2-view").classList.remove("active");
        document.querySelector("#step-count").innerText = "1"

        const collapElement = document.querySelector('.icon-back')
        collapElement.classList.remove('icon-back--clicked');
        document.getElementsByClassName('register__collapsible')[0].classList.remove('register__collapsible--open')
        return;
      } else {
        window.location.replace('/')
      }
    });

  }
  if (backBtn) backBtn.addEventListener('click', () => window.history.length > 1 ? window.history.back() : window.location.replace('/'));
};

triggerBackBtnStep2();